import Plyr from 'plyr';

document.addEventListener('DOMContentLoaded', () => {
    // Initialize Plyr on all elements with the `.js-player` class
    const players = document.querySelectorAll('.js-player');
    players.forEach(player => {
        new Plyr(player);
    });
});
